import React from 'react';

// import CookieBanner from '~components/custom/cookie-banner'
// import {CookieBanner as CefcomCookie} from '@ilc-technology/cefcom-react-cookie-banner'

import {IStoryBlokComponent} from '~interfaces/storyblock';
import '~src/styles/main.scss';
import Loadable from 'react-loadable'

interface ILayoutProps {
  pageContext: any;
  settings: IStoryBlokComponent;
}

const Layout: React.FC<ILayoutProps> = (
  {
    children,
    pageContext,
    settings,
  }) => {

    const WebUiHeader = Loadable({
      loader: () => import('~components/custom/header'),
      loading: () => <div/>
    });

    const WebUiFooter = Loadable({
      loader: () => import('~components/web-ui/footer'),
      loading: () => <div/>
    });

    const CentralHeader = Loadable({
      loader: () => import('~/src/components/custom/CentralHeader'),
      loading: () => <div/>
    });

    const CentralFooter = Loadable({
      loader: () => import('~/src/components/custom/CentralFooter'),
      loading: () => <div/>
    });

    // const renderCentralCookieBanner = (centralCookieData: any) => {
    //   return centralCookieData ? (
    //     <CefcomCookie
    //       showBanner={centralCookieData?.data?.showBanner}
    //       labels={centralCookieData?.data?.bannerServiceLabels}
    //     />
    //   ) : <CookieBanner/>
    // }
    return (
      <>
        {pageContext.centralHeaderData ? (
          <CentralHeader
            // @ts-ignore
            data={{...pageContext.centralHeaderData, menuLinks: settings?.content?.main_nav}}
            settings={settings}
          />
        ) : <WebUiHeader settings={settings}/>}
        <main style={{minHeight: '100vh'}}>{children}</main>
        {
          pageContext.centralFooterData ?
            <CentralFooter data={pageContext.centralFooterData}/> :
            <WebUiFooter settings={settings} legalLinks={pageContext.legalLinks} />
        }
        {/* {renderCentralCookieBanner(pageContext.centralCookieData)} */}
      </>
    );
  }
;

export default Layout;
